import { render, staticRenderFns } from "./ProvisionServiceTable.vue?vue&type=template&id=62642598&scoped=true"
import script from "./ProvisionServiceTable.vue?vue&type=script&lang=js"
export * from "./ProvisionServiceTable.vue?vue&type=script&lang=js"
import style0 from "./ProvisionServiceTable.vue?vue&type=style&index=0&id=62642598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62642598",
  null
  
)

export default component.exports